<div id="main" class="internal">
  <div id="summary" class="section summary">
    <div class="content-body">
      <div class="content">
        <div class="content-header clickable" (click)="Back()">
          <button class="costa-button back">
            <img src="../../../assets/images/back.svg" alt="Back button" />
          </button>
          <div class="step">
            {{ "stepper.step" | translate }} <b>3</b>
            {{ "stepper.of" | translate }} 3
          </div>
        </div>
        <div class="summary-box">
          <div class="subtitle">
            {{ "restaurant_booking.booking_recap" | translate }}
          </div>
          <h2 class="title">{{ restaurant!.name }}</h2>
          <div class="list">
            <div class="item">
              <div class="icon">
                <img src="../../../assets/images/calendar-slot.svg" alt="Calendar slot" />
              </div>
              <div class="text">
                <div class="title no-margin">
                  {{ dateService.dateToSummaryString(slot.date) }}.
                  {{ slot.date | date : "dd/MM/yyyy" }}
                  {{ "at" | translate }}
                  {{ slot.slot.slot_start }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../../assets/images/ticket-slot.svg" alt="Calendar" />
              </div>
              <div class="text">
                <div class="title no-margin">
                  {{ "restaurant_booking.booked_by" | translate }}
                  {{ auth.user?.displayName | titlecase }}
                </div>
              </div>
            </div>
            <div class="item user-group">
              <div class="icon">
                <img src="../../../assets/images/users-group.svg" alt="Ticket" />
              </div>
              <div class="text">
                <div class="title no-margin">
                  {{ "restaurant_booking.booked_for" | translate }}
                  {{ passengers.length }}
                  {{ "restaurant_booking.guests" | translate }}
                </div>
                <div class="groups">
                  <ul>
                    @for(el of passengers; track el.uuid_passenger) {
                    <li>{{ el.name }} {{ el.surname }}</li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="costa-button" type="button" (click)="Submit()">
          {{ "confirm" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>